import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import values from 'lodash.values';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import getDealerStatus from '@chama/utils/functions/dealer-status';
import getETALabel from '@chama/utils/functions/get-eta-label';
import NearbyDealerRow from './NearbyDealerRow';
import NearbyDealerTable from './NearbyDealerTable';
import './index.css';

const propTypes = {
  dealerList: PropTypes.array.isRequired,
  currentDealer: PropTypes.object.isRequired,
};

const getFormattedDealer = dealer => {
  const product = dealer.products[0];

  return {
    ...dealer,
    price: product.price,
    brand: product.brand,
    eta: dealer.deliveryDuration && getETALabel(dealer.deliveryDuration),
    status: getDealerStatus(dealer),
  };
};

const renderDealerList = dealerList => {
  const mapDealers = dealer => {
    return <NearbyDealerRow key={dealer.id} dealer={getFormattedDealer(dealer)} />;
  };

  if (dealerList.length) {
    return <NearbyDealerTable>{dealerList.map(mapDealers)}</NearbyDealerTable>;
  }

  return (
    <div className="DealersNearbyList__no_dealers_msg">
      <FormattedMessage
        id="there_is_no_other_dealers_nearby"
        defaultMessage="There is no other dealers nearby"
      />
    </div>
  );
};

const filterOutCurrentDealer = currentDealerId => {
  return dealer => dealer.id !== currentDealerId;
};

class DealersNearbyList extends Component {
  constructor(props) {
    const {
      intl: { formatMessage },
    } = props;
    super(props);

    this.state = {
      activeFilter: 'NEARBY_FILTER_CHEAPEST',
    };

    this.filters = {
      NEARBY_FILTER_CHEAPEST: {
        id: 'NEARBY_FILTER_CHEAPEST',
        label: formatMessage({
          id: 'price',
          defaultMessage: 'Price',
        }),
        primaryText: formatMessage({
          id: 'cheapest',
          defaultMessage: 'Cheapest',
        }),
        sortFn: (a, b) => {
          const priceA = a.products[0].price;
          const priceB = b.products[0].price;

          return a.isOpened > b.isOpened
            ? -1
            : a.isOpened < b.isOpened
            ? 1
            : priceA < priceB
            ? -1
            : priceA > priceB
            ? 1
            : 0;
        },
      },

      NEARBY_FILTER_FASTEST: {
        id: 'NEARBY_FILTER_FASTEST',
        label: formatMessage({
          id: 'nearby.filters.delivery_time',
          defaultMessage: 'ETA',
        }),
        primaryText: formatMessage({
          id: 'fastest',
          defaultMessage: 'Fastest',
        }),
        sortFn: (a, b) => {
          const durationA = parseInt(a.deliveryDuration, 10);
          const durationB = parseInt(b.deliveryDuration, 10);

          return a.isOpened > b.isOpened
            ? -1
            : a.isOpened < b.isOpened
            ? 1
            : durationA < durationB
            ? -1
            : durationA > durationB
            ? 1
            : 0;
        },
      },

      NEARBY_FILTER_BEST_RATED: {
        id: 'NEARBY_FILTER_BEST_RATED',
        label: 'Rating',
        primaryText: formatMessage({
          id: 'best_rated',
          defaultMessage: 'Best rated',
        }),
        sortFn: (a, b) => {
          return a.isOpened > b.isOpened
            ? -1
            : a.isOpened < b.isOpened
            ? 1
            : b.rating < a.rating
            ? -1
            : b.rating > a.rating
            ? 1
            : 0;
        },
      },
    };
  }

  onFilterChange = (event, index, value) => this.setState({ activeFilter: value });

  renderFilterDropdownItems = () => {
    const filtersIntoMenuItems = filter => {
      return (
        <MenuItem
          key={filter.id}
          value={filter.id}
          label={filter.label}
          primaryText={filter.primaryText}
        />
      );
    };

    return values(this.filters).map(filtersIntoMenuItems);
  };

  render() {
    const { dealerList, currentDealer } = this.props;
    const { activeFilter } = this.state;
    const modifiedList = dealerList
      .filter(filterOutCurrentDealer(currentDealer.id))
      .sort(this.filters[activeFilter].sortFn);

    return (
      <div className="DealersNearbyList">
        <div className="DealersNearbyList__current_dealer_wrapper">
          <div className="DealersNearbyList__title">
            <FormattedMessage id="order_dealer" defaultMessage="Order dealer" />
          </div>
          <NearbyDealerTable>
            <NearbyDealerRow key={currentDealer.id} dealer={getFormattedDealer(currentDealer)} />
          </NearbyDealerTable>
        </div>
        <div className="DealersNearbyList__list_wrapper">
          <div className="DealersNearbyList__title DealersNearbyList__title--with_dropdown">
            <FormattedMessage id="dealers_nearby" defaultMessage="Dealers nearby" />
            <div className="DealersNearbyList__filter_dropdown_wrapper">
              <DropDownMenu value={activeFilter} onChange={this.onFilterChange}>
                {this.renderFilterDropdownItems()}
              </DropDownMenu>
            </div>
          </div>
          <div>{renderDealerList(modifiedList)}</div>
        </div>
      </div>
    );
  }
}

DealersNearbyList.propTypes = propTypes;

export default injectIntl(DealersNearbyList);



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderDetailsLayout/DealersNearbyList/index.jsx